import { useState } from 'react'
import {
  SETUP_MFA_ENFORCED_ACTION_MESSAGE,
  SETUP_MFA_ENFORCED_GENERIC_ERROR,
  SETUP_MFA_ENFORCED_SUBTITLE,
  SETUP_MFA_ENFORCED_TITLE,
} from '../../constants/ui.labels'
import { ActionButton, ContentHeader, Error, mapError } from 'mfa'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Flex from '@talkdesk/cobalt-react-flex'

const SetupMFAEnforced = ({ onSetupMfa, errorCode }) => {
  const [isInProgress, setIsInProgress] = useState(false)

  const [prevErrorCode, setPrevErrorCode] = useState(errorCode)
  if (errorCode !== prevErrorCode) {
    setPrevErrorCode(errorCode)
    if (errorCode) setIsInProgress(false)
  }

  const handleOnSetup = () => {
    setIsInProgress(true)
    onSetupMfa()
  }

  const errorMessage =
    errorCode && mapError(errorCode, SETUP_MFA_ENFORCED_GENERIC_ERROR)

  return (
    <Flex direction='column' alignX='center'>
      <IconWithProvider name='security' size='large' color='red' />
      <ContentHeader
        title={SETUP_MFA_ENFORCED_TITLE}
        message={SETUP_MFA_ENFORCED_SUBTITLE}
      />
      <Error message={errorMessage} />
      <ActionButton
        htmlType='button'
        onClick={handleOnSetup}
        shape='full-width'
        isProcessing={isInProgress}
      >
        {SETUP_MFA_ENFORCED_ACTION_MESSAGE}
      </ActionButton>
    </Flex>
  )
}

export default SetupMFAEnforced
